import React from "react";
import { useParams, useNavigate } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
// import APIs
import GetOneApi from "../../api/customer/ticket/GetOne";
import CreateMessageApi from "../../api/customer/ticket/CreateMessage";

// import helpers
import { FromInt } from "../../helpers/NumberTools";
import { jalaliDateWithTime } from "../../helpers/convertDate.helper";

//import UIs
import TicketMessagesCard from "../../ui/cards/TicketMessagesCard";
import { ErrorNotify, SuccessNotify } from "../../ui/Toast";

//import skeletons
import TicketCardSkeleton from "../../ui/skeletons/TicketCard";
import TextArea from "../../ui/formElement/TextArea";
import SendBtn from "../../ui/formElement/SendBtn";

import FileUploader from "../../layout/common/FileUploader";

//icon
import ApartmentIcon from "@mui/icons-material/Apartment";
import SubjectIcon from "@mui/icons-material/Subject";
import QuizIcon from "@mui/icons-material/Quiz";
import InsertInvitationIcon from "@mui/icons-material/InsertInvitation";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import SendIcon from "@mui/icons-material/Send";

import { setIsLoading, setMetaData } from "../../redux/reducers/page";
import { setAuth } from "../../redux/reducers/customer";

const Ticket = () => {
  const [isLoaded, setIsLoaded] = React.useState(false);
  const [ticket, setTicket] = React.useState(null);
  const [medias, setMedias] = React.useState([]);
  const [text, setText] = React.useState(null);
  const [sending, setSending] = React.useState(false);

  const { id } = useParams();

  const navigate = useNavigate();

  // redux
  const dispatch = useDispatch();
  const { auth } = useSelector((state) => state.customerAuth);

  // find Ticket tickets
  const findticket = async () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });

    setIsLoaded(false);
    const result = await GetOneApi(auth.token, id);

    if (result.status !== 200) {
      ErrorNotify(JSON.parse(result.response).error);
      navigate(`/ticket`);
      return;
    }
    dispatch(
      setMetaData({
        title: `میشرت :    ${result.data.subject}`,
        description: `میشرت:   ${result.data.subject}`,
      })
    );
    setTicket(result.data);
    setIsLoaded(true);
  };
  const submitForm = async () => {
    if (text === null) {
      ErrorNotify(" متن پیام وارد نشده ");
      return;
    }

    setSending(true);
    const result = await CreateMessageApi(
      auth.token,
      id,
      text,
      medias.map((media, index) => {
        return { mediaId: media.id, title: `پیوست ${index + 1}` };
      })
    );
    if (result.status === 403) {
      dispatch(
        setAuth({
          token: null,
          customer: null,
          isAuthenticated: false,
          newBasket: null,
        })
      );
      return;
    }
    if (result.status === 400) {
      ErrorNotify(" مقادیر به درستی وارد نشده است ");
      setSending(false);
      return;
    }
    if (result.status !== 200) {
      ErrorNotify(JSON.parse(result.response).error);
      setSending(false);
      return;
    }
    if (result.status === 200) {
      SuccessNotify(" پیام شما با موفقیت ثبت شد");
      setIsLoaded(false);
      findticket();
      setMedias([]);
      setText(null);
      setSending(false);
      return;
    }
  };
  React.useEffect(() => {
    dispatch(setIsLoading(false));
    findticket();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="col-12 col-md-7  col-lg-6 col-xl-5  justify-content-center">
      <div className="row justify-content-center p-3 p-md-1">
        {" "}
        {isLoaded ? (
          <>
            <div className="row cards">
              <div className="col-12 ">
                <ApartmentIcon className="m-1" />
                {FromInt(ticket.department.text)}
              </div>
              <div className="col-12 ">
                <SubjectIcon className="m-1" /> {FromInt(ticket.subject)}
              </div>
              <div className="col-12 ">
                <QuizIcon className="m-1" /> {FromInt(ticket.status)}
              </div>
              <div className="col-12 ">
                <PriorityHighIcon className="m-1" />{" "}
                {FromInt(ticket.priority.text)}
              </div>
              <div className="col-12  ">
                <InsertInvitationIcon className="m-1" />{" "}
                <span dir="ltr">
                  {FromInt(jalaliDateWithTime(ticket.createdAt))}
                </span>
              </div>
            </div>
            {ticket.ticketMessages.map((message, index) => {
              return <TicketMessagesCard key={index} message={message} />;
            })}
            <div className="col-12">
              <div className="row  justify-content-center">
                <div className="col-12 p-0 ">
                  <TextArea
                    required={true}
                    name="text"
                    label="متن پیام  "
                    type="text"
                    multiline={true}
                    rows={5}
                    onChange={(e) => setText(e.target.value)}
                  />
                </div>
                <div className="col-12 p-0 ">
                  <FileUploader
                    token={auth.token}
                    dist={"tickets"}
                    setUploadedFiles={setMedias}
                    uploadedFiles={medias}
                  />
                </div>
                <div className="col-4 p-0 mt-5 ">
                  <SendBtn
                    variant="contained"
                    startIcon={<SendIcon />}
                    color="success"
                    loading={sending}
                    className="form-control"
                    click={submitForm}
                    name="ارسال پیام"
                  />
                </div>
              </div>
            </div>
          </>
        ) : (
          <TicketCardSkeleton />
        )}
      </div>
    </div>
  );
};

export default Ticket;
